import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { ReactComponent as FileExcelSVG } from 'assets/images/file-excel.svg'
import { ContainerStatusAssignment } from 'pages/institutionDetails/styled'

export const DetailsLink = styled(Link)`
  color: ${({ theme }) => theme.colors.secondary};

  &:hover {
    text-decoration: underline;
    transition: 0.3s;
  }
`

export const IdLabel = styled.label`
  color: ${({ theme }) => theme.colors.secondary};
`

export const ContainerHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings[6]};
`

export const ExcelIcon = styled(FileExcelSVG)`
  width: ${({ theme }) => theme.fontSizes.lg} !important;
`

export const ErrorItem = styled(ContainerStatusAssignment)`
  background: ${({ theme }) => theme.colors.dangerLight};

  label {
    color: ${({ theme }) => theme.colors.danger};
  }
`

export const OkItem = styled(ContainerStatusAssignment)`
  background: ${({ theme }) => theme.colors.blueLight};

  label {
    color: ${({ theme }) => theme.colors.blue};
  }
`

export const WarningItem = styled(ContainerStatusAssignment)`
  background: ${({ theme }) => theme.colors.warningLight};

  label {
    color: ${({ theme }) => theme.colors.warning};
  }
`
